import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  Nav, NavItem,
  TabContent, TabPane,
  Spinner,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import {
  Colxx,
  Separator,
} from '../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import { gAPI_QuickReplies_listByGroup } from '../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ReplyListItem from './components/ReplyListItem';
import AddNewReply from './components/AddNewReply';
import classnames from 'classnames';
import no_replytemplate from '../../../../assets/no_replytemplate.png';

function Index({ propertyId, locale }) {
  const [replyList, setReplyList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('replytemplate');

  useEffect(() => {
    LoadData();
  }, [propertyId]);

  const LoadData = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_QuickReplies_listByGroup}?groupId=${getGroupID()}&languageCode=${locale}`,
    })
      .then((res) => {
        setReplyList(res.data);
        setLoading(false);
      })
      .catch((err) => console.log('err', err));
  };

  const toggleModal = () => {
    setVisible(!visible);
  };
  const toggleMenu = (tab) => {

    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  if (loading) {
    return <div className="loading" />;
  }

  return (
    <Fragment>
      <Row className="survey-app">
        <Colxx xxs="12" lg="12">

          <Nav tabs className="card-header-tabs separator-tabs  ml-0  mb-1">
            <NavItem className="text-center" style={{ width: 'auto', background: '' }}>
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                to="#"
                location={{}}
                className={classnames({
                  active: activeTab === 'replytemplate',
                  'nav-link': true,
                })}
                onClick={() => toggleMenu('replytemplate')}
              >
                <span
                  style={{ color: `${activeTab === "replytemplate" ? 'var(--theme-color-1)' : '#8f8f8f'}` }}
                >
                  Reply Templates
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              {!loading && (
                <Fragment>
                  <div className="text-zero top-right-button-container ml-3">
                    <Button
                      color="primary"
                      size="xs"
                      outline
                      className="top-right-button mr-1 "
                      onClick={toggleModal}
                    >
                      + Add New
                    </Button>
                  </div>
                </Fragment>
              )}
            </NavItem>
          </Nav>
        </Colxx>
        {/* <Colxx xxs="3" className="mb-2">
              {!loading && (
                <Fragment>
                  <div className="text-zero top-right-button-container">
                    <Button
                      color="primary"
                      size="md"
                      className="top-right-button mr-1"
                      onClick={toggleModal}
                    >
                      Add New
                    </Button>
                  </div>
                </Fragment>
              )}

            </Colxx> */}

      </Row>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="replytemplate">
          <Row style={{ marginTop: '20px' }}>
            {!loading ? (
              <>
                {replyList && replyList.length > 0 ? (
                  replyList.map((item, index) => (
                    <ReplyListItem
                      key={`reply_item_${index}`}
                      item={item}
                      toggleModal={toggleModal}
                      LoadData={LoadData}
                    />
                  ))
                ) : (
                  <Colxx xxs="12" className="mb-4 text-center"><img className='w-30' style={{ marginTop: '5rem' }} src={no_replytemplate}></img></Colxx>
                )}
              </>
            ) : (
              <div className="loading" />
            )}
          </Row>
        </TabPane>
      </TabContent>
      <AddNewReply
        toggleModal={toggleModal}
        formLabel="Create a New Template"
        visible={visible}
        LoadData={LoadData}
      />
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
